import { combineReducers } from 'redux';
import authData from './authentication';

import machineCutting from './machineCutting';
export default function createReducer() {
    return combineReducers({
        authData,
        machineCutting
    });
}